/* http://keith-wood.name/calendars.html
   Farsi/Persian localisation for calendars datepicker for jQuery.
   Javad Mowlanezhad -- jmowla@gmail.com. */
(function ($) {
    'use strict';
    /* jshint -W100 */
    $.calendarsPicker.regionalOptions.fa = {
        renderer: $.calendarsPicker.defaultRenderer,
        prevText: '<span class="icon-0036"></span>',
        prevStatus: 'نمایش ماه قبل',
        prevJumpText: '&#x3c;&#x3c;',
        prevJumpStatus: '',
        nextText: '<span class="icon-0096-1"></span>',
        nextStatus: 'نمایش ماه بعد',
        nextJumpText: '&#x3e;&#x3e;',
        nextJumpStatus: '',
        currentText: 'امروز',
        currentStatus: 'نمایش ماه جاری',
        todayText: 'امروز',
        todayStatus: 'نمایش ماه جاری',
        clearText: 'حذف تاریخ',
        clearStatus: 'پاک کردن تاریخ جاری',
        closeText: 'بستن',
        closeStatus: 'بستن بدون اعمال تغییرات',
        switchCalendarText: 'میلادی',
        switchCalendarStatus: 'تغییر تقویم به میلادی',
        submitText: 'انتخاب تاریخ',
        submitStatus: 'انتخاب تاریخ',
        yearStatus: 'نمایش سال متفاوت',
        monthStatus: 'نمایش ماه متفاوت',
        weekText: 'هف',
        weekStatus: 'هفته‌ی سال',
        dayStatus: 'انتخاب D, M d',
        defaultStatus: 'انتخاب تاریخ',
        isRTL: true
    };
    $.calendarsPicker.setDefaults($.calendarsPicker.regionalOptions.fa);
})(jQuery);

function notEmpty(obj) {
    var flag = ((typeof obj === "undefined") || (obj === null) || (obj === "") || (obj.length == 0)) ? false : true;
    return flag;
};

function localNumber(input, calendar) {
    var flag = (calendar.name.toLowerCase() == 'persian');

    return flag ? (input + "").toString().replace(/[0-9]/gi, function (n) {
        var map = ["\u06F0", "\u06F1", "\u06F2", "\u06F3", "\u06F4", "\u06F5", "\u06F6", "\u06F7", "\u06F8", "\u06F9"];
        return map[parseInt(n, 10)];
    }) : input;
}
